import { useMemo, type ComponentProps } from 'react';
import { cityByAirport } from '@voll-intelligence/domain';
import { LegStepper as KitLegStepper } from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import { legStepperCopy } from '../../../shared/ui/leg_stepper_copy.js';

/** O stepper do roteiro do kit (#4997) com os textos do catálogo e o cadastro de
 *  aeroportos do domain. */
export function LegStepper(props: Omit<ComponentProps<typeof KitLegStepper>, 'text'>) {
  const { locale } = useGenUiI18n();
  const copy = useMemo(() => legStepperCopy(locale), [locale]);
  return <KitLegStepper {...props} text={{ copy, locale, cityOf: cityByAirport }} />;
}
